export { default } from './File';
